import { usePermissions } from '@/shared/hooks/usePermissions';

import { type UserPermission } from '@/shared/types/permissions';

import React from 'react';

import { Navigate } from 'react-router-dom';

export interface PermissionRouteProps {
  permissions: UserPermission[];
  children: React.ReactNode;
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({ permissions, children }) => {
  const { hasPermission } = usePermissions();
  const canAccess = permissions.some((permission) => hasPermission(permission));

  if (!canAccess) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};
